export const createInitialTeilentsorgungsraum = () => {
    return {
        index: -1,
        verwaltungseinheitSchluessel: null,
        verwaltungseinheitBezeichnung: ""
    };
};
